import type { MessageData } from '@inbox-demo-nx/types';
import { safeJSONParse } from '@inbox-demo-nx/utils';

export function getMessageData(options: MessageData) {
  return JSON.stringify(options);
}

export function parseMessageData<
  TMessageData extends MessageData = MessageData
>(data: string | null): TMessageData | null {
  return safeJSONParse(data || '');
}
